import React from 'react';
import Image from "next/legacy/image";
import Head from 'next/head';

import styles from '../styles/About.module.scss';
import Link from 'next/link';

const Story = () => {
  return (
    <>
      <Head>
        <title>About us | Noundles</title>
      </Head>
      <div className="blue-gradient">
        <div className={styles.rainbow}>
          <div className={styles.hero}>
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-5 d-flex flex-column justify-content-end">
                  <Image src="/book.png" alt="Book" width={447} height={447} />
                </div>
                <div className="col-12 col-md-7 d-flex flex-column justify-content-center order-first order-md-last">
                  <h1 className="display-4 title mb-3">Noundles</h1>
                  <p className="lead">
                    Noundles is the most successful NFT project in the <a href="https://nouns.wtf/vote">Nouns DAO</a> ecosystem, with over 4,000 ETH ($15M) 
                    in sales across three collections. We’re on a mission to entertain & inspire people around the world 
                    through the power of collaboration, innovation and transparency. 
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="my-5 pt-5">
            <div className="lead my-3">
              <p>
                Noundles has a long tradition of being an innovator in Web3. We 
                are a pioneer in the Web3 <a href="https://en.wikipedia.org/wiki/Player_versus_environment">PvE</a> space, 
                launching <a href="https://twitter.com/OttoSuwenNFT/status/1464736563540148233">one of the first</a> NFT 
                PvE games in November 2021 alongside Wolf Game and Feudalz. Noundles invented the whitelist marketplace, giving users the ability 
                to win access to up-and-coming projects by bidding on them with Noundles’ token, 
                the $RAINBOW. We helped to launch <a href="https://twitter.com/nouncil">The Nouncil</a>: a first of its kind CC0 
                governing body of Nouns derivatives. Noundles also
                invented passive staking, which is the ability for holders to earn rewards 
                for holding an NFT without having to transfer it to a staking contract. 
                <br/>
              </p>
              <p>
                <center>
                <blockquote className="twitter-tweet"><p lang="en" dir="ltr"><a href="https://twitter.com/Noundles?ref_src=twsrc%5Etfw">@Noundles</a> congrats <a href="https://t.co/VUdRzieAP2">pic.twitter.com/VUdRzieAP2</a></p>&mdash; KEEM 🍿 (@KEEMSTAR) <a href="https://twitter.com/KEEMSTAR/status/1493010903738068999?ref_src=twsrc%5Etfw">February 13, 2022</a></blockquote> 
                <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
                </center>
              </p>
              <p>
                <br/>
                Being in the Nouns ecosystem has also given Noundles access to marketing done 
                by the Nouns project. Never was this more acute than in Super Bowl LVI, when the 
                iconic Nouns glasses appeared in a <a href="https://www.youtube.com/watch?v=c3fELinsiAI">Budweiser ad</a> promoting
                Bud Light NEXT. Noundles registered over 175 ETH ($470K) in sales in the two weeks leading up to the Super Bowl, 
                appearing on a VaynerMedia Twitter Spaces alongside Gary Vaynerchuk’s team. 
              </p>
              <p>
                The Noundles 
                Rainbow Shop (our whitelist marketplace) has given away 80 ETH ($200K) <a href="https://www.noundles.io/shop/winners">in prizes</a> to our 
                community, in addition to securing our holders access to numerous valuable allowlists, 
                like Loveless City, ZooVerse, Arcade Land, Beyond Earth, KUMALEON and more. Our first 
                whitelist raffle got 109 Noundles holders access to the <a href="https://opensea.io/collection/genesis-creepz">Creepz by OVERLORD</a> mint, which 
                reached a peak value of $16,000 per token in January 2021 – creating $1.7M in value for our holders.
              </p>
              <p>
                Over this time we have become insanely good at the mechanics of running an NFT project. 
                We’ve launched a complete overhaul of our website, rewritten our contracts from the ground up 
                and cultivated a community of loyal and devoted holders. We’ve seen so many projects launch without 
                a creative vision or voice, often with generic art from websites like Fiverr. These cash grabs tarnish 
                the NFT space, bringing down the ceiling for all projects. Noundles wants to amplify the voices of 
                the good artists. We believe we can help them find their users and launch successful NFT collections.   
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Story;
